import { createAction, props } from '@ngrx/store';

interface ModalShow {
  title: string;
  text: string;
  text2?: string;
  text3?: string;
  actionOnAccept: () => void;
  actionOnCancel?: () => void;
  acceptButtonText: string;
  noShowButtonBack?: boolean;
}
export const modalShow = createAction(
  '[Modal] Show',
  props<ModalShow>(),
);

export const modalHide = createAction('[Modal] hide');
